import {createAction} from '@reduxjs/toolkit'

import {PendingPaymentStatusType} from '@web/core/constants'

import {AccountKey} from './interfaces/account'

/** 간편결제 계좌 선택 */
export const selectEasyBankAccount = createAction<Maybe<AccountKey>>('account/selectEasyBankAccount')

/** 충전 계좌 선택 */
export const selectRechargeAccount = createAction<Maybe<AccountKey>>('account/selectRechargeAccount')

export type PendingPaymentActionType = {
    /** 비동기 결제 가능 여부 */
    pendingPaymentStatus: PendingPaymentStatusType
}

export const pendingPaymentAction = createAction<PendingPaymentActionType>('pendingPaymentAction')
